<template lang="html">
  <v-dialog v-model="dialog" fullscreen>
    <template v-slot:activator="{ on }">
      <v-btn color="secondary" v-on="on">
        Create new TAKT.sequence
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="secondary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Sequence Editor</v-toolbar-title>
      </v-toolbar>
      <v-container fluid>
        <InfoBox
            v-if="show_info_box"
            @clickOutside="closeInfoBox()"
            >
            <template #button-top>
              <WaggonInfoNavButton
                v-if="showUp()"
                direction="up"
                width="80px"
                @click.native="routeUp()"
                />
            </template>
            <template #button-right>
              <WaggonInfoNavButton
                v-if="showRight()"
                direction="right"
                height="80px"
                @click.native="routeRight()"
                />
            </template>
            <template #button-bottom>
              <WaggonInfoNavButton
                v-if="showDown()"
                direction="down"
                width="80px"
                @click.native="routeDown()"
                />
            </template>
            <template #button-left>
              <WaggonInfoNavButton
                v-if="showLeft()"
                direction="left"
                height="80px"
                @click.native="routeLeft()"
                />
            </template>
            <template #default>
            <WaggonInfo
              :waggon="{}"
              >
              <template #header>
                <WaggonInfoHeader
                  v-for="(work_package) in work_packages_large"
                  :key="'header' + work_package.id"
                  :width="'100%'"
                  :color="work_package.color"
                  :text="work_package.token"
                  :icon="work_package.icon"
                  />
              </template>
              <template #body>
                <template v-if="show_info_box_body === 'info'">
                  <WaggonInfoBody
                    :color="work_packages_large[work_packages_large_index].color"
                    :work_package="work_packages_large[work_packages_large_index]"
                    :info_box="true"
                    >
                    <template #body-content="body_slot">
                      <StandardDataField
                        :value="body_slot.work_package.name"
                        readonly="true"
                        />
                      <StandardDataField
                        :value="body_slot.work_package.description"
                        flat="true"
                        placeholder="description"
                        :resizable="true"
                        :readonly="true"
                        />
                      <v-divider color="black"></v-divider>
                        <StandardFlexBox>
                          <!-- attributes planned -->
                          <StandardFlexBox
                            class="pa-1"
                            width="50%"
                            direction="column"
                            >
                            attributes planned
                            <StandardFlexBox>
                              <StandardDataField
                              :value="body_slot.work_package.time_effort_planned"
                              icon="speed"
                              width="28%"
                              :type="'number'"
                              :readonly="true"
                              />
                              <div style="width: 8%; line-height: 33px; text-align: center;">/</div>
                              <StandardDataField
                                :value="body_slot.work_package.manpower_planned"
                                icon="accessibility"
                                width="28%"
                                :type="'number'"
                                :readonly="true"
                                />
                              <div style="width: 8%; line-height: 33px; text-align: center;">=</div>
                              <StandardDataField
                                :value="body_slot.work_package.manpower_planned === 0 || isNaN(Math.round((body_slot.work_package.time_effort_planned/body_slot.work_package.manpower_planned)*100) / 100)?
                                        '':Math.round((body_slot.work_package.time_effort_planned/body_slot.work_package.manpower_planned)*100) / 100"
                                icon="timer"
                                width="28%"
                                :readonly="true"
                                />
                            </StandardFlexBox>
                            <StandardFlexBox>
                              <StandardDataField
                                :value="body_slot.work_package.quantity_value"
                                icon="drag_indicator"
                                width="33%"
                                :type="'number'"
                                :readonly="true"
                                />
                              <StandardDataField
                                :value="body_slot.work_package.quantity_unit"
                                icon="drag_indicator"
                                width="33%"
                                :readonly="true"
                                />
                            </StandardFlexBox>
                          </StandardFlexBox>
                          <!-- attributes actual -->
                          <StandardFlexBox
                            style="border-left: solid 1px black"
                            class="pa-1"
                            width="50%"
                            direction="column"
                            >
                            attributes actual
                            <StandardFlexBox>
                              <StandardDataField
                                :value="body_slot.work_package.manpower_actual === 0?
                                        '':Math.round((body_slot.work_package.duration_actual*body_slot.work_package.manpower_actual)*100) / 100"
                                icon="speed"
                                icon_actual="true"
                                width="28%"
                                :readonly="true"
                                />
                              <div style="width: 8%; line-height: 33px; text-align: center;">=</div>
                              <StandardDataField
                                :value="body_slot.work_package.manpower_actual"
                                icon="accessibility"
                                icon_actual="true"
                                width="28%"
                                :type="'number'"
                                :readonly="true"
                                />
                              <div style="width: 8%; line-height: 33px; text-align: center;">x</div>
                              <StandardDataField
                                :value="body_slot.work_package.duration_actual"
                                icon="timer"
                                icon_actual="true"
                                width="28%"
                                :type="'number'"
                                :readonly="true"
                                />
                            </StandardFlexBox>
                          </StandardFlexBox>
                        </StandardFlexBox>
                      <v-divider color="black"></v-divider>
                      <!-- Contact -->
                      <StandardFlexBox
                        direction="column"
                        :no_wrap="true"
                        >
                        contact
                        <StandardDataField
                          width="100%"
                          :value="body_slot.work_package.contact_name"
                          icon="account_circle"
                          :readonly="true"
                          />
                        <StandardDataField
                          width="100%"
                          :value="body_slot.work_package.contact_phone_number"
                          icon="call"
                          :readonly="true"
                          />
                        <StandardDataField
                          width="100%"
                          :value="body_slot.work_package.contact_email"
                          icon="email"
                          :readonly="true"
                          />
                        </StandardFlexBox>
                    </template>
                  </WaggonInfoBody>
                </template>
                <template v-if="show_info_box_body === 'worksteps'">
                  <WaggonInfoBody
                    :color="work_packages_large[work_packages_large_index].color"
                    :work_package="work_packages_large[work_packages_large_index]"
                    :info_box="true"
                    >
                    <template #body-content="body_slot">
                      WORK.steps ({{body_slot.work_package.work_steps.length}})
                      <StandardStep
                        v-for="(work_step) in body_slot.work_package.work_steps"
                        :key="'work_step' + work_step.id"
                        :step="work_step"
                        :readonly="true"
                        step_type="worksteps"
                      />
                    </template>
                  </WaggonInfoBody>
                </template>
                <template v-if="show_info_box_body === 'qualitysteps'">
                  <WaggonInfoBody
                    :color="work_packages_large[work_packages_large_index].color"
                    :work_package="work_packages_large[work_packages_large_index]"
                    :info_box="true"
                    >
                    <template #body-content="body_slot">
                      QUALITY.steps ({{body_slot.work_package.quality_steps.length}})
                      <StandardStep
                        v-for="(quality_step) in body_slot.work_package.quality_steps"
                        :key="'quality_step' + quality_step.id"
                        :step="quality_step"
                        :readonly="true"
                        step_type="qualitysteps"
                      />
                    </template>
                  </WaggonInfoBody>
                </template>
                <template v-if="show_info_box_body === 'defectsteps'">
                  <WaggonInfoBody
                    :color="work_packages_large[work_packages_large_index].color"
                    :work_package="work_packages_large[work_packages_large_index]"
                    :info_box="true"
                    >
                    <template #body-content="body_slot">
                      DEFECT.steps ({{body_slot.work_package.defect_steps.length}})
                      <StandardStep
                        v-for="(defect_step) in body_slot.work_package.defect_steps"
                        :key="'defect_step' + defect_step.id"
                        :step="defect_step"
                        :readonly="true"
                        step_type="defectsteps"
                      />
                    </template>
                  </WaggonInfoBody>
                </template>
                <template v-if="show_info_box_body === 'nosteps'">
                  <WaggonInfoBody
                    :color="work_packages_large[work_packages_large_index].color"
                    :work_package="work_packages_large[work_packages_large_index]"
                    :info_box="true"
                    >
                    <template #body-content="body_slot">
                      <StandardFlexBox
                        direction="column"
                        align_content="center"
                        justify_content="center"
                        height="calc(100% - 36px)"
                        >
                        <div
                          :class="`mb-1 ${body_slot.work_package.color}--text text--darken-3 font-weight-medium`"
                          v-if="!body_slot.work_package.work_steps ||
                              body_slot.work_package.work_steps.length === 0"
                          >
                          ... no WORK.steps created
                        </div>
                        <div
                          :class="`mb-1 ${body_slot.work_package.color}--text text--darken-3 font-weight-medium`"
                          v-if="!body_slot.work_package.quality_steps ||
                              body_slot.work_package.quality_steps.length === 0"
                          >
                          ... no QUALITY.steps created
                        </div>
                        <div
                          :class="`mb-1 ${body_slot.work_package.color}--text text--darken-3 font-weight-medium`"
                          v-if="!body_slot.work_package.defect_steps ||
                              body_slot.work_package.defect_steps.length === 0"
                          >
                          ... no DEFECT.steps created
                        </div>
                        <div
                          :class="`mb-1 ${body_slot.work_package.color}--text text--darken-3 font-weight-medium`"
                          v-if="!body_slot.work_package.handover_steps ||
                              body_slot.work_package.handover_steps.length === 0"
                          >
                          ... no Handover.steps created
                        </div>
                      </StandardFlexBox>
                    </template>
                  </WaggonInfoBody>
                </template>
              </template>
            </WaggonInfo>
          </template>
        </InfoBox>
        <v-row align="center" justify="center">
          <v-col cols="8" align="center" justify="center">
            <!-- <Train> -->
              <!-- <TaktArea :project_length="new_custom_sequence_waggons.length"> -->
              <div class="sequence-card">
                <TrainHead />
                  <v-hover
                    v-for="(waggon, index) in new_custom_sequence_waggons"
                    :key="waggon.id"
                    >
                    <!-- slot-scope="{ hover }" -->
                    <!-- @click.native="clickWaggon(waggon.work_packages)" -->
                      <Waggon
                      :workpackage_count="waggon.work_packages.length"
                      >
                        <template #content>
                        <!-- <StandardHover v-if="hover"/> -->
                            <draggable
                            class="draggable-grid"
                            :style="`grid-template-columns: ${gridColumns(waggon.work_packages.length)}`"
                            :value="waggon.work_packages"
                            @input="setSWorkPackages({index: index, work_packages: $event})"
                            v-bind="sequence_options"
                            >
                              <v-hover
                              v-for="(workpackage, wp_index) in waggon.work_packages"
                              :key="wp_index"
                              >
                                <WorkPackage
                                slot-scope="{ hover }"
                                :color="workpackage.color"
                                :icon="workpackage.icon"
                                :token="workpackage.token"
                                :workpackage_count="waggon.work_packages.length"
                                >
                                <StandardHover v-if="hover"/>
                            </WorkPackage>
                          </v-hover>
                        </draggable>
                      </template>
                      <template #badge>
                        <v-badge
                          color="error"
                          icon="close"
                          z-index="5"
                          @click.native="removeWaggon(index)"
                        >
                        </v-badge>
                      </template>
                    </Waggon>
                  </v-hover>
                <TrainTail />
              </div>
              <!-- </TaktArea> -->
            <!-- </Train> -->
          </v-col>
        </v-row>
      </v-container>

      <!-- <v-card-text> -->
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">Pick the number of Waggons</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2">Pick your TAKT.time</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 3" step="3">Fill the Waggons with Work Packages</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3">Finalize Sequence</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card
                class="mb-12 pa-2"
                color="color-3"
                min-height="200px"
              >
                <v-row>
                  <v-col cols="12" class="ma-2 pa-2">
                    <h2>Number of Waggons</h2>
                    <StandardTextfield icon="crop_landscape" color="secondary"
                                       type="number" min="1" style="width: 10%"
                                       :value="new_custom_sequence_waggons.length" @changeValue="changeWaggonLength($event)" />
                  </v-col>
                </v-row>
              </v-card>

              <v-btn color="secondary" @click="nextStep()">Continue</v-btn>
              <v-btn disabled text>Step back</v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mb-12 pa-2"
                color="color-3"
                min-height="200px"
              >
                <v-row>
                  <v-col cols="12" class="ma-2 pa-2">
                    <h2>Pick your TAKT.time</h2>
                    <StandardTaktTimeDropdown
                    :value="getNewCustomSequence.takt_time.value + ' ' + getNewCustomSequence.takt_time.unit"
                    color="secondary lighten-2"
                    :options="takt_times"
                    @changeValue="setNewCustomSequenceTaktTime($event)" />
                    <div class="mt-5"></div>
                  </v-col>
                </v-row>
              </v-card>

              <v-btn color="secondary" @click="nextStep()">Continue</v-btn>
              <v-btn @click="stepBack()" text>Step back</v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card
                class="mb-12 pa-2"
                color="color-3"
                min-height="200px"
              >
                <h2>Pick Work Packages</h2>

                <h3>Your custom Work Packages</h3>
                <v-pagination
                  v-model="page"
                  :length="Math.ceil(getPagination.total / getPagination.limit)"
                  circle
                  @input="changePage($event)"
                ></v-pagination>
                  <draggable
                  v-model="custom_work_packages"
                  v-bind="draggable_workpackage_options"
                  >
                    <v-hover
                      v-for="workpackage in custom_work_packages"
                      :key="'wp'+workpackage.id"
                      >
                        <WorkPackage
                        slot-scope="{ hover }"
                        class="my-workpackage ml-2"
                        :color="workpackage.color"
                        :icon="workpackage.icon"
                        :token="workpackage.token"
                        :workpackage_count="1"
                        @click.native="clickWaggon([workpackage])"
                        >
                        <StandardHover v-if="hover"/>
                    </WorkPackage>
                  </v-hover>
                </draggable>
                <div class="clear"></div>
                <h3>TAKT.ing community Work Packages</h3>
                <draggable
                v-model="getCommunityWorkPackages"
                v-bind="draggable_workpackage_options"
                >
                  <v-hover
                      v-for="workpackage in getCommunityWorkPackages"
                      :key="'cwp'+workpackage.id"
                      >
                      <WorkPackage
                      slot-scope="{ hover }"
                      class="my-workpackage ml-2"
                      :color="workpackage.color"
                      :icon="workpackage.icon"
                      :token="workpackage.token"
                      :workpackage_count="1"
                      @click.native="clickWaggon([workpackage])"
                      >
                      <StandardHover v-if="hover"/>
                    </WorkPackage>
                  </v-hover>
                </draggable>
                <div class="clear"></div>
                <h3>Create new TAKT.package</h3>
                <WorkPackageEditorDialog work_package_editor_dialog="false" />

              </v-card>

              <v-btn color="secondary" @click="nextStep()" >Continue</v-btn>
              <v-btn @click="stepBack()" text>Step back</v-btn>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-card
                class="mb-12 pa-2"
                color="color-3"
                min-height="200px"
              >
                <h2>Finalize your Sequence</h2>
                Name:
                <StandardTextfield color="secondary lighten-2"
                                   type="text" min="1" style="width: 400px"
                                   class="mb-5"
                                   :value="getNewCustomSequence.name"
                                   @changeValue="setNewCustomSequenceName($event)" />

              <StandardFlagDropdown
              :value="getNewCustomSequence.country.name"
              color="secondary"
              :options="countries"
              @changeValue="setNewCustomSequenceCountry($event)" />
              <StandardTextfield class="mt-5" color="secondary lighten-2" placeholder="Hashtags"
                                 type="text" min="1" style="width: 50%"
                                 :value="getNewCustomSequenceHashtags" @changeValue="updateHashtags($event)" />

              </v-card>

              <v-btn color="secondary" disabled>Continue</v-btn>
              <v-btn @click="stepBack()" text>Step back</v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      <!-- </v-card-text> -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" :disabled="e1 !== 4" text @click="finishCreateDialog()">Accept</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import draggable from "vuedraggable"
import { WorkPackageLargeMixin } from '@/mixins/WorkPackageLarge.mixin.js';

import { mapGetters, mapActions } from 'vuex';
import WorkPackageEditorDialog from '@/components/WorkPackages/WorkPackageEditorDialog.component.vue';
// import Train from '@/components/ProjectTaktPlan/Train.component.vue';
// import TaktArea from '@/components/ProjectTaktPlan/TaktArea.component.vue';
import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue';
import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
import StandardHover from '@/components/StandardComponents/StandardHover.component.vue';
import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue';
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue';
import StandardFlagDropdown from '@/components/StandardComponents/StandardFlagDropdown.component.vue';
import StandardTaktTimeDropdown from '@/components/StandardComponents/StandardTaktTimeDropdown.component.vue';

import {
  getCountries,
  getValidTaktTimes
} from '../../helpers/data';


export default {
  name: 'SequenceEditorDialog',
  props: ['sequence_editor_dialog'],
  components: {
    WorkPackageEditorDialog,
    // Train,
    // TaktArea,
    TrainHead,
    Waggon,
    WorkPackage,
    StandardHover,
    TrainTail,
    StandardTextfield,
    StandardFlagDropdown,
    StandardTaktTimeDropdown,
    draggable,
  },
  mixins: [WorkPackageLargeMixin],
  data: () => ({
    dialog: false,
    page: 1,
    e1: 1,
    countries: [],
    takt_times: [],
    waggon_large_dialog: false,
    draggable_workpackage_options: {
      group: {
        name: 'draggable_sequence',
        pull: 'clone',
        put: false
      }
    },
    sequence_options: {
      group: {
        name: 'draggable_sequence',
        pull: true,
        put: true
      }
    }
  }),
  created() {
    this.dialog = this.sequence_editor_dialog;
    this.countries = getCountries();
    this.takt_times = getValidTaktTimes();
    this.countries.push({
      flag: 'flag',
      name: 'Other'
    });
    this.requestCWorkPackages();
  },
  computed: {
    ...mapGetters('Sequence', [
      'getNewCustomSequence'
    ]),
    ...mapGetters('Community', [
      'getCommunityWorkPackages'
    ]),
    ...mapGetters('WorkPackage', [
      'getPagination'
    ]),
    getNewCustomSequenceHashtags: function () {
      return this.getNewCustomSequence.hashtags.join(' ');
    },
    custom_work_packages: {
       get() {
           return this.$store.state.WorkPackage.work_packages;
       },
       set(value) {
           this.$store.commit('WorkPackage/set_work_packages', value);
       }
    },
    new_custom_sequence_waggons: {
       get() {
           return this.$store.state.Sequence.new_custom_sequence.waggons;
       },
       set(value) {
           this.$store.commit('Sequence/set_new_custom_sequence_waggons', value);
       }
    }
  },
  methods: {
    changeWaggonLength(len){
      this.changeNewCustomSequenceWaggonLength({
        curr_len: this.new_custom_sequence_waggons.length,
        new_len: len
      });
    },
    removeWaggon(index){
      this.new_custom_sequence_waggons.splice(index, 1);
    },
    stepBack(){
      if (this.e1 > 1) {
        this.e1--;
      }
    },
    nextStep(){
      if (this.e1 === 1) {
        this.requestCustomWorkPackages();
      }
      this.e1++;
    },
    finishCreateDialog(){
      this.createCompleteSequence()
      .then(() => {
        this.dialog = false;
        this.e1 = 1;
      })
      .catch(() => {
      });
    },
    changePage(page){
      this.page = page;
      this.requestCustomWorkPackages(page);
    },
    updateHashtags(hashtags){
      let hashtag_arr = hashtags.split(' ');
      for (var i = 0; i < hashtag_arr.length; i++) {
        if (hashtag_arr[i].startsWith('#')) {
          hashtag_arr[i] = hashtag_arr[i].substr(1);
        }
      }
      this.setNewCustomSequenceHashtags(hashtag_arr);
    },
    gridColumns(workpackage_count) {
      if (workpackage_count) {
        let column_count = 2
        if (workpackage_count !== 2) {
          column_count = Math.ceil(workpackage_count/2)
        }
        return `repeat(${column_count}, ${100/column_count}%)`
      } else {
        return 'repeat(1, 100%)'
      }
    },
    ...mapActions('Sequence', [
      'changeNewCustomSequenceWaggonLength',
      'setSWorkPackages',
      'setNewCustomSequenceName',
      'setNewCustomSequenceTaktTime',
      'setNewCustomSequenceCountry',
      'setNewCustomSequenceHashtags',
      'createCompleteSequence'
    ]),
    ...mapActions('WorkPackage', [
      'requestCustomWorkPackages'
    ]),
    ...mapActions('Community', [
      'requestCWorkPackages'
    ])
  }
}
</script>

<style lang="css" scoped>
.draggable-grid {
  width: 58px;
  height: 38px;
  display: grid;
}
.my-workpackage {
  position: relative !important;
  float: left;
}
.sequence-card {
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  width: 100%;
}
</style>
